import styled from "styled-components/macro";
import { media } from "../../utils";

export const CarrousselActionNavigationIcon = styled.svg({});

export const CarrousselItem = styled.div({
  display: "none",
  width: "100%",
  minHeight: "260px",
  borderRadius: "16px",
  boxShadow: "0px 8px 12px 0px #2D292629, 0px -2px 2px 0px #2D29260D",
  padding: "24px 16px",
  margin: "20px",
  [media.md()]: {
    maxWidth: "60%",
  },
  [media.lg()]: {
    maxWidth: "280px",
    margin: "10px",
  },
});

export const CarrousselBodyText = styled.span(({ theme }) => ({
  color: theme.color.neutral["03"],
}));

export const Carroussel = styled.div(({ showCard, showCardRange = [] }) => ({
  display: "flex",
  justifyContent: "center",
  flexWrap: "wrap",
  [`${CarrousselItem}:nth-child(${showCard})`]: {
    display: "block",
  },
  [media.lg()]: {
    ...showCardRange.reduce(
      (showCards, showCardItem) => ({
        ...showCards,
        [`${CarrousselItem}:nth-child(${showCardItem})`]: {
          display: "block",
        },
      }),
      {}
    ),
  },
}));

export const CarrousselControlAction = styled.button(({ theme }) => ({
  borderRadius: "50%",
  backgroundColor: "transparent",
  border: "none",
  padding: "3px",
  margin: "0 12px",
  cursor: "pointer",
  display: "flex",
  div: {
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    backgroundColor: theme.color.neutral["04"],
  },
  "&.active": {
    border: `1px solid ${theme.color.brandPrimary.light}`,
    div: {
      width: "10px",
      height: "10px",
      backgroundColor: theme.color.brandPrimary.light,
    },
  },
}));

export const CarrousselControl = styled.div(({ carrousselItems }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  paddingTop: "20px",
  ".CarrousselControl.Navigation": {
    display: "none",
  },
  [media.lg()]: {
    display: carrousselItems.length <= 3 ? "none" : null,
    ".CarrousselControl.Navigation": {
      display: "flex",
    },
  },
}));

Carroussel.Item = CarrousselItem;
CarrousselControl.Action = CarrousselControlAction;
